module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/japanese-5ec1e38bba75d7bf.png"+" 48w",
        images: [{path: __webpack_public_path__ + "assets/images/japanese-5ec1e38bba75d7bf.png",width: 48,height: 48}],
        src: __webpack_public_path__ + "assets/images/japanese-5ec1e38bba75d7bf.png",
        toString: function(){return __webpack_public_path__ + "assets/images/japanese-5ec1e38bba75d7bf.png"},
        
        width: 48,
        height: 48
      }